// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e877f670","453":"ecc2d9df"}[chunkId] + ".chunk.js";
};